import { readIdentity } from './readFlight';
let failures = 0;
let started: number | undefined;
let checkStarted: number | undefined;
export function recordAuthCheck() { checkStarted = performance.now(); }
export function recoveryWait(delay: number) {
  return Math.max(1000, Math.min(30_000, delay) - (checkStarted === undefined ? 0 : performance.now() - checkStarted));
}
export function accountRequestSucceeded(identity: number) {
  if (identity === readIdentity()) window.dispatchEvent(new Event('account-connection-restored'));
}
export function recordAuthRecovery(reason: string) {
  if (reason === 'AUTH_UNAVAILABLE') {
    if (started === undefined) started = performance.now();
    failures += 1;
  } else { failures = 0; started = undefined; checkStarted = undefined; }
}
export function recoveryDelay() { return Math.min(30_000, 10_000 * 2 ** Math.min(2, Math.max(0, failures - 1))); }
export function recoveryMessage() {
  return '网络暂时不稳，正在自动重新连接……' + (started !== undefined && performance.now() - started >= 180_000 ? '请检查电脑网络。' : '');
}
